module.exports = __webpack_public_path__ + "img/wait-clock.fedfa81c.svg";